import { TFunction, useTranslation } from 'next-i18next';
import React, { useState } from 'react';

import { AssetItemProps } from '@/shared/components/molecules/ChooseAsset/ChooseAsset';
import Tabs from '@/shared/components/molecules/ChooseAsset/Tabs';
import TabsContent from '@/shared/components/molecules/ChooseAsset/TabsContent';
import { EntityType } from '@/shared/constant/enums';
interface ChooseLocationProps {
  setselectedAsset: (val: AssetItemProps) => void;
  defaultType?: number;
  defaultAsset?: AssetItemProps;
  companyTypeId: number | undefined;
}

// TODO: en version

const tabsListTemp = (t: TFunction) => [
  {
    label: t('farm'),
    key: EntityType.FARM,
  },
  {
    label: t('packhouse'),
    key: EntityType.PACKHOUSE,
  },
];

const ChooseLocation: React.FC<ChooseLocationProps> = ({
  defaultAsset,
  defaultType,
  setselectedAsset,
  // companyTypeId,
}) => {
  const { t } = useTranslation('common');
  const [activeKey, setActiveKey] = useState<number>(() => {
    if (defaultAsset) {
      return defaultAsset.entityTypeId;
    }
    return defaultType ? defaultType : tabsListTemp(t)[0].key;
  });
  return (
    <>
      {/* TODO: remove if type is only farm */}
      {/* {companyTypeId === 2 ? (
        <></>
      ) : ( */}
      <Tabs
        tabsList={tabsListTemp(t)}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
      />
      {/* )} */}
      <TabsContent
        activeKey={activeKey}
        defaultAsset={defaultAsset}
        setselectedAsset={setselectedAsset}
      />
    </>
  );
};
export default ChooseLocation;
